Vue.component('bus-sort', {
    props: {
        buses: Array
    },
    data: function(){
        return {
            showSortWindow: false,
        }
    },
    mounted: function(){
        this.$nextTick(function () {
            $( "#searchSorting" ).buttonset();
        });
    },
    created: function(){

    },
    methods: {
        sortBuses: function(sortFn){
            var sortedBuses = sortFn();
            this.$emit('input', sortedBuses);
        },

        byPriceAsc: function(){
            return this.buses.sort(function (item1, item2) {
                return item1.ticketPriceWeb - item2.ticketPriceWeb;
            });
        },
        byPriceDesc: function(){
            return this.byPriceAsc().reverse();
        },

        byProviderAsc: function(){
            return this.buses.sort(function (item1, item2) {
                if (item1.companyName.toLowerCase() > item2.companyName.toLowerCase()){
                    return 1;
                }
                if (item1.companyName.toLowerCase() < item2.companyName.toLowerCase()){
                    return -1;
                }
                return 0;
            });

        },
        sortProviderDesc: function(){
            return this.byProviderAsc().reverse();
        },

        byDepTimeAsc: function(){
            return this.buses.sort(function (item1, item2) {
                return item1.departureDate - item2.departureDate;
            });

        },
        sortDepTimeDesc: function(){
            return this.byDepTimeAsc().reverse();
        },

        byDurationDepAsc: function(){
            return this.buses.sort(function (item1, item2) {
                return item1.busTime - item2.busTime;
            });
        },
        byDurationDepDesc: function(){
            return this.byDurationDepAsc().reverse();
        },
        // popup window

        openWindow: function () {
            $('.pop-sorting').fadeToggle("fast");
        },
        closeWindow: function(){
            $('.pop-sorting').hide();
        },
        clickedOutside: function () {
            if(!$(event.target).closest('.pop-sorting').length) {
                if($('.pop-sorting').is(":visible")) {
                    $('.pop-sorting').hide();
                }
            }
        }

    }
});